<template>
  <div class="guide-view">
    <div class="mask-view relative-view"></div>
    <template v-if="index === 0">
      <div class="z-index-99999" :style="style">
        <el-popover
          popper-class="z-index-max"
          placement="bottom-end"
          width="430"
          trigger="manual"
          :value="visible"
          :key="index"
        >
          <div class="guide-content">
            <div class="guide-top">
              <div class="image">
                <img src="@/assets/guide/guide-0.png" />
              </div>
              <div class="text">点击这里可以【批量导入】指认商品</div>
            </div>
            <div class="btn-group">
              <el-button @click="hideGuide">跳过</el-button>
              <el-button type="primary" @click="getSetting(index + 1)">下一步</el-button>
            </div>
          </div>
          <el-button class="button" slot="reference" size="small" type="primary"
            >批量指认商品</el-button
          >
        </el-popover>
      </div>
    </template>
    <template v-if="index === 1">
      <div class="z-index-99999" :style="style">
        <el-popover
          popper-class="z-index-max"
          placement="bottom-start"
          width="430"
          trigger="manual"
          :value="visible"
          :key="index"
        >
          <div class="guide-content">
            <div class="guide-top">
              <div class="image">
                <img src="@/assets/guide/guide-1.png" />
              </div>
              <div class="text">
                按照模版上传商品信息成功匹配之后， 会按照商品编号自动添加到对应的商品 列表
              </div>
            </div>
            <div class="btn-group">
              <el-button @click="hideGuide">跳过</el-button>
              <el-button type="primary" @click="getSetting(index + 1)">下一步</el-button>
            </div>
          </div>
          <span slot="reference" style="visibility: hidden;">不定规格商品明细</span>
        </el-popover>
      </div>
    </template>
    <template v-if="index === 2">
      <div class="z-index-99999" :style="style">
        <el-popover
          popper-class="z-index-max"
          placement="bottom-end"
          width="430"
          trigger="manual"
          :value="visible"
          :key="index"
        >
          <div class="guide-content">
            <div class="guide-top">
              <div class="image">
                <img src="@/assets/guide/guide-2.png" />
              </div>
              <div class="text">
                这里可以查看【上传记录】和【失败原因】
              </div>
            </div>
            <div class="btn-group">
              <el-button @click="hideGuide">跳过</el-button>
              <el-button type="primary" @click="getSetting(index + 1)">下一步</el-button>
            </div>
          </div>
          <el-button class="button btn-record" slot="reference" size="small">
            导入记录
          </el-button>
        </el-popover>
      </div>
    </template>
    <template v-if="index === 3">
      <div class="z-index-99999" :style="style">
        <el-popover
          popper-class="z-index-max"
          placement="bottom-end"
          width="430"
          trigger="manual"
          :value="visible"
          :key="index"
        >
          <div class="guide-content">
            <div class="guide-top">
              <div class="image">
                <img src="@/assets/guide/guide-2.png" />
              </div>
              <div class="text">
                指认商品编辑完成后，点击【完成指认】结束指认
              </div>
            </div>
            <div class="btn-group">
              <el-button @click="hideGuide">跳过</el-button>
              <el-button type="primary" @click="getSetting(index + 1)">下一步</el-button>
            </div>
          </div>
          <el-button class="button btn-record" slot="reference" size="small">
            完成指认
          </el-button>
        </el-popover>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: -1,
      rect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      visible: false,
      timer: null
    }
  },
  props: {
    guideRefs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    style() {
      let { top, left, width, height } = this.rect
      return {
        position: 'absolute',
        top: top + 'px',
        left: left + 'px',
        width: width + 'px',
        height: height + 'px'
      }
    }
  },
  async mounted() {
    window.addEventListener('resize', this.resizeHandle)
    this.getSetting(0)
    console.log('mounted')
    const body = document.querySelector('.app-wrapper')
    if (body.append) {
      body.append(this.$el)
    } else {
      body.appendChild(this.$el)
    }
  },
  destroyed() {
    this.$el.remove()
    window.removeEventListener('resize', this.resizeHandle)
  },
  methods: {
    // 停止引导
    hideGuide() {
      this.$emit('hideGuide')
    },
    // 窗口缩放事件监听，重新计算位置
    resizeHandle() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        let index = this.index
        this.getSetting(index)
      }, 200)
    },
    // 获取预定位置的信息
    getSetting(index) {
      if (index >= this.guideRefs.length) {
        return this.hideGuide()
      }
      this.visible = false
      let dom = this.guideRefs[index]
      if (dom.$el) {
        dom = dom.$el
      }
      console.log('所有的ref' + this.guideRefs)
      this.rect = dom.getBoundingClientRect()
      this.index = index
      this.$nextTick(() => {
        this.visible = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mask-view {
  opacity: 0.6;
  background-color: #000;
  width: 100%;
  height: 100%;
  z-index: 90000;
  position: absolute;
  top: 0;
  left: 0;
}
.z-index-99999 {
  z-index: 99999;
}
.guide-content {
  padding: 13px;
  .guide-top {
    display: flex;
    .image {
      width: 100px;
      height: 62px;
    }
    .text {
      flex: 1;
      padding-left: 10px;
      margin-top: 10px;
    }
  }
  .btn-group {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
}
.button {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
